/* global ViewController, WebView */
var bpmFormController = new ViewController({
    directory : "views/public",
    name: "bpmForm",
    container: "main",
    route: "bpm-form"
}) ;

bpmFormController.prepareDataOnEnter = function(formAndToken, callback){
    var splitted = formAndToken.split(",") ;
    var form = splitted[0];
    var token = splitted[1];
    this.api.public.getBpmInstance(token, function(err, processInstance){
        if(err) {return callback(err) ;}
        
        if(!processInstance){
            return callback(null, { unkown: true }) ;
        }
        
        var alreadyDone = processInstance.state === "done" || processInstance.state === "obsolete" ;
        
        this.api.public.getBpmForm(form, processInstance.id, function(err, formConfig){
            if(err) {return callback(err) ;}
            

            formConfig.fields.forEach(function(field){
                field.alreadyDone = alreadyDone ;
            }) ;
            
            var query = "" ;
            if(window.location.search){
                query = window.location.search ;
            }
            if(query){
                formConfig.fields.forEach(function(field){
                    if(field.pdfUrl){
                        if(field.pdfUrl.indexOf("?") !== -1){
                            field.pdfUrl = field.pdfUrl+query.replace(/^\?/, "&") ;
                        }else{
                            field.pdfUrl = field.pdfUrl+query ;
                        }
                        field.pdfUrlDownload = field.pdfUrl.replace("/inline/", "/attachment/")+"&disposition=attachment" ;
                    }
                }.bind(this)) ;
            }

            this.api.public.bpmFormOpened(formConfig.id, processInstance.id, function(err){
                if(err) {return callback(err) ;}

                return callback(null, { 
                    formConfig: formConfig,
                    processInstance: processInstance,
                    alreadyDone: alreadyDone
                }) ;
                
            }.bind(this)) ; 
        }.bind(this)) ;
    }.bind(this)) ;
};

bpmFormController.onValidate = function(){
    this.view.updateData() ;
    var errors = [] ;
    var fieldValues = [] ;
    var files = [] ;
    this.data.formConfig.fields.forEach(function(field){
        var isShown = true ;
        if(field.show_if){
            isShown = this.view.runExpr(field.show_if) && !field.already_checked ;
        }
        if(!isShown){ return ; }

        if(field.type === "template_check" || field.type === "doc_read_check"){
            if(!field.value){
                errors.push(field.name+" : "+WebView.tr("bpm.pleaseCheck")) ;
            }
            fieldValues.push({
                field_id: field.id,
                value: field.value,
                chosen_text: field.check_text
            }) ;
        } else if(field.type === "template_choice" || field.type === "doc_choice"){
            if(!field.value){
                errors.push(field.name+" : "+WebView.tr("bpm.pleaseMakeAChoice")) ;
            }
            var chosenText = "";
            field.choices.some(function(choice){
                if(choice.code === field.value){
                    chosenText = choice.name;
                    return true ;
                }
            }) ;
            fieldValues.push({
                field_id: field.id,
                value: field.value,
                chosen_text: chosenText
            }) ;
        } else if(field.type === "doc_read_yes_no"){
            if(!field.valueYes && !field.valueNo){
                errors.push(field.name+" : "+WebView.tr("bpm.pleaseMakeAChoice")) ;
            }
            fieldValues.push({
                field_id: field.id,
                value: !!field.valueYes,
                chosen_text: field.valueYes?field.choice_accept_text:field.choice_refuse_text
            }) ;
        } else if(field.type === "upload_file"){
            if(!field.value){
                errors.push(field.name+" : "+WebView.tr("bpm.pleaseChooseAFile")) ;
            }
            fieldValues.push({
                field_id: field.id,
                isFile: true,
                value: files.length
            }) ;
            files.push(field.value) ;
        }
    }.bind(this)) ;
    if(errors.length>0){
        return WebView.error(errors.join("\n")) ;
    }
    this.view.longTask(function(done){
        var file1 = files[0];
        var file2 = files[1];
        var file3 = files[2];
        var file4 = files[3];
        var file5 = files[4];
        var file6 = files[5];
        var file7 = files[6];
        var file8 = files[7];
        var file9 = files[8];
        var file10 = files[9];
        this.api.public.bpmFormValidate(this.data.formConfig.id, this.data.processInstance.id, JSON.stringify(fieldValues),
            file1, file2, file2, file3, file4, file5, file6, file7, file8, file9, file10,
             function(err){
            if(err) {return done(err) ;}
            this.data.validated = true;
            this.view.render() ;
            done() ;
            WebView.info(WebView.tr("bpm.formValidatedSuccess")) ;
        }.bind(this)) ; 
    }.bind(this)) ;
} ;


module.exports = bpmFormController ;